;(function() {
  'use strict'

  Factory.$inject = ["$q", "userService", "usersResource"];
  angular.module('core.factories').factory('UserStorage', Factory)

  /* @ngInject */
  function Factory($q, userService, usersResource) {
    /**
     * @class UserStorage
     * @desc instantiates a new user storage
     */
    function UserStorage() {
      var user = userService.get()

      // ensure we have the profile questions data path
      if (!user.data) {
        user.data = {}
      }

      // HACK: backend returns empty {} as [] so we need to make sure its an object
      if (
        !user.data.profileQuestions ||
        _.isArray(user.data.profileQuestions)
      ) {
        user.data.profileQuestions = {}
      }

      this.profileQuestions = _.cloneDeep(user.data.profileQuestions)
      this.identity = user.id
    }

    /**
     * get
     * @desc gets a profile question's answer
     * @param {String} key - the profile question's key
     * @return {Object} answer - the profile question's answer
     */
    UserStorage.prototype.get = function(key) {
      if (!key) {
        return
      }

      return this.profileQuestions[key]
    }

    /**
     * update
     * @desc updates a profile question's data
     * @param {String} key - the profile question's key
     * @param {Object} value - the answer to save
     */
    UserStorage.prototype.update = function(key, value) {
      this.profileQuestions[key] = value
    }

    /**
     * save
     * @desc saves the user's profile question answers to the BE
     */
    UserStorage.prototype.save = function() {
      var self = this

      return $q(function(resolve, reject) {
        var user = userService.get()

        _.assign(user.data.profileQuestions, self.profileQuestions)

        usersResource
          .updateCurrent(user)
          .success(resolve)
          .error(reject)
      })
    }

    return UserStorage
  }
})()
